//@ts-nocheck

import React from 'react';
import { Card } from 'antd';
import EdelweissReaderLink from '../ReviewCopy/EdelweissReaderLink';
import { useWebReaderGalleyAccess } from '../hooks/useWebReaderGalleyAccess';
import DrcActionDownloadOption from './DrcActionDownloadOption';
import DrcActionRequestOption from './DrcActionRequestOption';
import { Translate } from '@above-the-treeline/localization';
import { useDownloads } from '../Downloads/containers/DownloadsDataStore';
import LocalizedDate from '../Localization/LocalizedDate';
import ReviewCopyActionTooltip from '../ReviewCopy/ReviewCopyActionTooltip';
import { CancelRequestLabel } from '../UI/Actions/CancelRequest';
import { EnableRequestLabel } from '../UI/Actions/EnableRequest';
import { useRequests } from '../Requests/containers/RequestsDataStore';
import TitleType from '../../types/Title';
import './drcActionsCard.less';

type DrcActionsCardProps = {
	title: TitleType;
};

export default function DrcActionsCard({ title }: DrcActionsCardProps) {
	const { sku } = title;
	const { hasWebReaderGalleyAccess } = useWebReaderGalleyAccess();

	const downloadsDataStore = useDownloads();
	const requestsDataStore = useRequests();

	const getDownloadOptionLabel = () => {
		const { downloads, isLoading } = downloadsDataStore.state;
		if (isLoading) return <React.Fragment />;

		const download = downloads && downloads.find(req => req.sku === sku);
		if (!download) {
			return (
				<ReviewCopyActionTooltip
					headerText={<Translate id="download_the_drc" />}
					createdDate={title.digitalCreatedDate}
					updatedDate={title.digitalUpdatedDate}
				/>
			);
		}
		return (
			<>
				<Translate id="drc_downloaded" />
				&nbsp;
				{download.downloadDate && (
					<LocalizedDate dateString={download.downloadDate} />
				)}
			</>
		);
	};

	const getRequestOptionLabel = () => {
		const { requests, isLoading } = requestsDataStore.state;

		if (isLoading) {
			return <React.Fragment />;
		}

		const drcRequest = requests.find(req => req.sku === sku);

		if (drcRequest) {
			if (drcRequest.status === 30) {
				return (
					<EnableRequestLabel
						submittedDate={drcRequest.submittedDate}
					/>
				);
			}

			return (
				<CancelRequestLabel submittedDate={drcRequest.submittedDate} />
			);
		}

		return (
			<ReviewCopyActionTooltip
				headerText={'Request DRC'}
				createdDate={title.digitalCreatedDate}
				updatedDate={title.digitalUpdatedDate}
			/>
		);
	};

	return (
		<Card className="drc-actions-card" size="small">
			{hasWebReaderGalleyAccess(sku) && (
				<div className="drc-action-btn-container">
					<EdelweissReaderLink title={title} buttonType="round" />
					<div className="drc-action-label">
						<Translate id="read_online" />
					</div>
				</div>
			)}
			{(title.isDownloadable || title.isRequestable) && (
				<div style={{ marginTop: '5px' }}>
					{title.isDownloadable ? (
						<div className="drc-action-btn-container">
							<DrcActionDownloadOption
								title={title}
								tooltipPlacement={''}
							/>
							<div className="drc-action-label">
								{getDownloadOptionLabel()}
							</div>
						</div>
					) : (
						<div className="drc-action-btn-container">
							<DrcActionRequestOption
								title={title}
								tooltipPlacement={''}
							/>
							<div className="drc-action-label">
								{getRequestOptionLabel()}
							</div>
						</div>
					)}
				</div>
			)}
			<div className="clear" />
		</Card>
	);
}
